import { IUpdateCacheRequest, UpdateCache, UpdateCacheRequest } from '../contracts';
import axios from 'axios';
import LogCannon from '@ace-clublabs/log-cannon';
import { mapAddressToLambdaRequest } from './SubmitNewJoinFormDataApi';

export const UpdateCacheApi =
  (endpoint: string): UpdateCache =>
  async (request: UpdateCacheRequest) => {
    try {
      const apiRequest = mapUpdateCacheApiRequest(request);

      const response = await axios.post(endpoint, apiRequest);
      LogCannon.blast('UpdateCacheApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      LogCannon.warn('UpdateCacheApi error', e as any);
    }
  };

const mapUpdateCacheApiRequest = (request: UpdateCacheRequest): IUpdateCacheRequest => {
  const hasMailingAddress = request?.data?.mailingAddress !== undefined;
  if (!hasMailingAddress) return request as IUpdateCacheRequest;

  return {
    ...request,
    data: {
      ...request.data,
      mailingAddress: mapAddressToLambdaRequest(request.data.mailingAddress!),
    },
  } as IUpdateCacheRequest;
};
